(function authInterceptorDefinition() {
    'use strict';

    angular.module("Auth")
        // el interceptor setea el bearer token en los requests y acciona a las responses que son de 401
        // para refrescar el token
        .factory('authInterceptor', [
            '$injector', '$q', '$timeout',
            function ($injector, $q, $timeout) {
                return {
                    request: function authInterceptorRequest(config) {
                        if (!config.withCredentials) {
                            $injector.get('auth').setHeader(config);
                        }

                        return config || $q.when(config);
                    },
                    responseError: function authInterceptorResponseError(response) {
                        if (response.status === 401) { // unauthorized

                            // si es un refresh el que dio 401 salgo
                            if (response.config.url.indexOf('/Home/DoRefresh') >= 0) {
                                $injector.get('auth').logout();
                                return $q.reject(response);
                            }

                            // si es un request al Home entonces lo ignoro (hago un reject).
                            if (response.config.url.indexOf('/Home') === 0)
                                return $q.reject(response);

                            var deferred = $q.defer();

                            // intento refrescar el token antes de fallar.
                            $injector.get('auth').refreshToken()
                                .then(function (result) {
                                    if (result === true) {
                                        // se refrescó el token, hago nuevamente el request original
                                        $injector.get("$http")(response.config)
                                            .then(function (response) {
                                                deferred.resolve(response);
                                            }, function (response) {
                                                deferred.reject(response);
                                            });
                                    } else {
                                        deferred.reject(response);
                                    }
                                },
                                    function (refreshResponse) {
                                        // El reject lo hago con el 401 original.
                                        deferred.reject(response); // token refresh failed
                                        return;
                                    });

                            return deferred.promise; // return the deferred promise
                        }

                        return $q.reject(response);
                    }
                };
            }
        ])
        .config([
            '$httpProvider', function (httpProvider) {
                httpProvider.interceptors.push('authInterceptor');
            }
        ]);
})();
